/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PraticaCambioStatoForm { 
    nuovo_stato: PraticaCambioStatoFormNuovoStatoEnum;
    version: number;
    commento?: string;
}
export enum PraticaCambioStatoFormNuovoStatoEnum {
    IN_ATTESA_OTP = 'IN_ATTESA_OTP',
    RICHIESTA_SOTTOMESSA = 'RICHIESTA_SOTTOMESSA',
    RICHIESTA_IN_LAVORAZIONE = 'RICHIESTA_IN_LAVORAZIONE',
    RICHIESTA_ACCETTATA = 'RICHIESTA_ACCETTATA',
    RICHIESTA_RIFIUTATA = 'RICHIESTA_RIFIUTATA',
    VOUCHER_ASSEGNATI = 'VOUCHER_ASSEGNATI',
    VOUCHER_CONSEGNATI = 'VOUCHER_CONSEGNATI'
};



